<template>
    <div v-loading="isloading"
         :element-loading-text="loadingText">
        <el-descriptions class="margin-top" title="" :column="4" size="small" border>
            <el-descriptions-item v-for="(value,key,index) in entityDatabyFilter" :key="index">
                <template slot="label">
                    {{key}}
                </template>
                {{value}}
            </el-descriptions-item>
        </el-descriptions>

        <el-descriptions class="margin-top" title="" :column="1" size="small" border v-if="AlertMessage!=''||ComparisonResult!=''">
            <el-descriptions-item label="预警信息" :label-class-name="labelclass" :content-class-name="contentclass" v-if="AlertMessage!=''">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td v-for="(tditem1,index) in JSON.parse(AlertMessage)" :key="'col'+index">{{tditem1.longname}}</td>
                    </tr>
                    <tr>
                        <td v-for="(tditem2,index) in JSON.parse(AlertMessage)" :key="'data'+index">{{tditem2.value}}</td>
                    </tr>
                </table>

            </el-descriptions-item>
            <el-descriptions-item label="对比结果" v-if="ComparisonResult !== ''">
                <div v-html="ComparisonResult">

                </div>
            </el-descriptions-item>
        </el-descriptions>

        <el-form ref="compareform" :model="form" label-width="100px" class="compareForm" size="small">
            <el-form-item label="选择区域">
                <el-select v-model="form.regionIds" multiple placeholder="请选择区域">
                    <el-option v-for="item in regionoptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="原水对比">
                <el-switch v-model="form.IsOrignWater"></el-switch>
            </el-form-item>
            <el-form-item label="选择背景水" v-show="!form.IsOrignWater">
                <el-select v-model="form.bgwaterId" filterable placeholder="">
                    <el-option v-for="item in bgwateroptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="startCalc">开始溯源</el-button>
            </el-form-item>
            <el-form-item v-show="isSyncBtnShow">
                <el-button :disabled="!isSyncBtnShow" @click="startSync">同步对比结果</el-button>
            </el-form-item>
        </el-form>
        <el-descriptions class="margin-top" title="数据图表" :column="2" v-show="showResultChart" border>
            <el-descriptions-item>
                <template slot="label">
                    三维图
                </template>
                <plotchart :chartData="calcData.chart3d" :chartType="2" />
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    等值线图
                </template>
                <contour-plot :chartData="calcData.contour" />
            </el-descriptions-item>
        </el-descriptions>

        <el-descriptions class="margin-top" title="匹配结果数据图表" :column="2"
                         v-show="showResultChart && targetSample1.chart3d !== undefined" border>
            <el-descriptions-item>
                <template slot="label">
                    三维图
                </template>
                <plotchart :chartData="targetSample1.chart3d" :chartType="2" />
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    等值线图
                </template>
                <contour-plot :chartData="targetSample1.contour" />
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top" title="匹配结果数据图表" :column="2"
                         v-show="showResultChart && targetSample2.chart3d !== undefined" border>
            <el-descriptions-item>
                <template slot="label">
                    三维图
                </template>
                <plotchart :chartData="targetSample2.chart3d" :chartType="2" />
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    等值线图
                </template>
                <contour-plot :chartData="targetSample2.contour" />
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top" title="匹配结果数据图表" :column="2"
                         v-show="showResultChart && targetSample3.chart3d !== undefined" border>
            <el-descriptions-item>
                <template slot="label">
                    三维图
                </template>
                <plotchart :chartData="targetSample3.chart3d" :chartType="2" />
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    等值线图
                </template>
                <contour-plot :chartData="targetSample3.contour" />
            </el-descriptions-item>
        </el-descriptions>

    </div>
</template>

<script>
import {
    getEntityFull,
    tableInfo2,
    getListPage,
    Calc,
    UpdateCalcId,
    getEntityFullByCalcId
} from '@/api/utils';
    import XEUtils from 'xe-utils';
    import Plotchart from "@/components/Plotchart.vue";
    import ContourPlot from "@/components/ContourPlot.vue";

    export default {
        name: 'CompareObs',
        components: {ContourPlot, Plotchart},
        props: {
            tableName: {
                type: String
            },
            meta: {
                type: Object
            }
        },
        data() {
            return {
                isloading: true,
                loadingText:'',
                isSyncBtnShow: false,
                calcid:0,
                entityData: {},
                tableColumns: [],
                regionoptions: [],
                bgwateroptions: [
                    {
                        label: "未选择",
                        value: 0
                    }],
                AlertMessage: "",
                ComparisonResult: "",
                AlertType: -1,
                form: {
                    regionIds: [],
                    IsOrignWater: true,
                    bgwaterId: 0
                },
                notShowCols: ['Id', 'AlertMessage', 'ComparisonResult', 'BGWaterId', 'Type2WaterId', 'EquipmentId'],
                calcData: {},
                targetSample1: {},
                targetSample2: {},
                targetSample3: {},
                showResultChart: false,
            }
        },
        computed: {
            entityDatabyFilter() {
                var newEntityData = {};
                var that = this;

                var keys = Object.keys(this.entityData);
                this.tableColumns.forEach(function (col) {
                    if (that.notShowCols.indexOf(col.Field) == -1) {
                        var key = that.findKeybyCol(keys, col.Field);
                        if (key != undefined) {
                            newEntityData[col.Title] = that.formatData(col, that.entityData[key]);
                        }
                    }
                });
                return newEntityData;
            },
            labelclass() {
                if (this.AlertType == 1) return 'red-alert-label';
                else if (this.AlertType == 2) return 'yellow-alert-label';
                return '';
            },
            contentclass() {
                if (this.AlertType == 1) return 'red-alert-content';
                else if (this.AlertType == 2) return 'yellow-alert-content';
                return '';
            }
        },
        async created() {
            await this.getTableCols();
            await this.getEntityFullData();
            await this.getRegionData();
            await this.getBGwaterData();
            this.isloading = false;
        },
        methods: {
            //方法:根据列名查找列对象
            findColbyName(name) {
                return this.tableColumns.find((item) => {
                    return item.Field == name;
                });
            },
            findKeybyCol(keys, colname) {
                return keys.find((item) => {
                    return item == colname;
                });
            },
            //获取:Entityfull数据
            async getEntityFullData() {
                let res = await getEntityFull(this.tableName, { id: this.meta.id }).catch(() => { });
                this.entityData = res.Data.entity;
            },
            padleft(content,total, pad) {
                return (Array(total).join(pad || 0) + content).slice(-total);
            },
            formatData(col, val) {
                let reValue = val;
                if (col != undefined && col.IsFormat) {
                    switch (col.FormatOption.type) {
                        case 'number'://数字:保留2位小数
                            reValue = val.toFixed(2);
                            break;
                        case 'datetime'://时间:yyyy-MM-dd HH:mm:ss.S 不格式化后支持毫秒
                            reValue = XEUtils.toDateString(val, 'yyyy-MM-dd HH:mm:ss');
                            break;
                        case 'array'://数组:根据Option自定义格式化
                            if (val == null)
                                reValue = val;
                            else if (col.FormatOption.template != undefined && col.FormatOption.template != null && col.FormatOption.template != '') {
                                reValue = "";
                                val.forEach(cellItem => {
                                    reValue += XEUtils.toFormatString(col.FormatOption.template, cellItem) + '\r\n';
                                });
                            }
                            else
                                reValue = val.join(',');
                            break;
                        default:
                    }
                }
                return reValue;
            },
            //获取:DataTable列定义
            async getTableCols() {
                var params = { tableName: this.tableName };
                let res = await tableInfo2(params).catch(() => { });
                var tableColumnsRes = res.Data;
                for (var i = 0; i < tableColumnsRes.length; i++) {
                    var col = tableColumnsRes[i];
                    col.FormatOption = col.FormatOption == null || col.FormatOption === '' ? {} : JSON.parse(col.FormatOption);
                }
                this.tableColumns = tableColumnsRes;
            },
            //获取:背景水列表数据
            async getBGwaterData() {
                let res = await getListPage('BGWater', {}).catch(() => { });
                if (res.Code === 1) {
                    res.Data.list.forEach(item => {
                        var wateritem = {
                            label: "Id:" + this.padleft(item.Id,4,'') + " 设备:" + item.EquipmentSN + " 创建时间:" + item.CreateTime,
                            value: item.Id
                        };
                        this.bgwateroptions.push(wateritem);
                    });
                }
            },
            //获取:区域列表数据
            async getRegionData() {
                let res = await getListPage('Region', {}).catch(() => { });
                if (res.Code === 1) {
                    res.Data.list.forEach(item => {
                        var regionitem = {
                            label: item.Name,
                            value:item.Id
                        };
                        this.regionoptions.push(regionitem);
                    });
                }
            },
            //事件:开始溯源
            async startCalc() {
                let that = this;
                that.loadingText = "努力计算中...请稍等";
                that.isloading = true;
                let bgWaterId = !that.form.IsOrignWater ? that.form.bgwaterId : -1
                let params = {
                    observationId: that.meta.id,
                    bgwaterId: bgWaterId,
                    regionIds: that.form.regionIds.join(',')
                };
                let res = await Calc(params).catch(() => { });
                //console.log(111, res)
                if(res.Code === 2){
                    let msg = res.Msg
                    //console.log(222, msg)
                    that.$message.error(msg);
                }
                else if (res.Code === 1) {
                    that.calcData = {}
                    that.targetSample1 = {}
                    that.targetSample2 = {}
                    that.targetSample3 = {}
                    that.calcid = res.Data.items[res.Data.items.length - 1];
                    //显示返回的预警和对比信息
                    that.AlertMessage = res.Data.AlertMessage;
                    that.AlertType = parseInt(res.Data.AlertType);
                    let CComparisonResult = res.Data.ComparisonResult;
                    let targetIds = res.Data.TargetsIds;
                    that.ComparisonResult = CComparisonResult.length > 0 ? CComparisonResult.join('<br>') : '';
                    // this.calcData = await getEntity("Calculate", {id: this.calcid});
                    // let bgWaterResult = null;

                    let result = await getEntityFullByCalcId({calcId: that.calcid, subBgwater: true});
                    let rn = Math.random().toString(36).substring(3,9)
                    if(result.Code === 1){
                        let chart3dData = result.Data.chart3d;
                        let countourData = result.Data.contour;
                        if(bgWaterId > 0){
                            let bgWaterResult = await getEntityFull("BGWater", {id : bgWaterId});
                        }
                        that.calcData = result.Data.entity;
                        that.calcData.chart3d = {
                            pdata: result.Data.chart3d,
                            size: { width: 500, height: 400 },
                            chartid: that.tableName + that.calcData.Id + '-' + rn  + '-' + '3d'
                        };
                        that.calcData.contour = {
                            pdata: result.Data.contour,
                            peaks: that.calcData.Peaks,
                            size: { width: 530, height: 400 },
                            chartid: that.tableName + that.calcData.Id + '-' + rn + '-' + 'contour'
                        };
                    }
                    rn = Math.random().toString(36).substring(3,9)
                    for(let i=0;i<targetIds.length;i++){
                        if(targetIds[i]>0){
                            let targetEntity = await getEntityFull("Sample",{id : targetIds[i]});
                            if(targetEntity.Code === 1){
                                let sample = targetEntity.Data.entity;
                                sample.chart3d = {
                                    pdata: targetEntity.Data.chart3d,
                                    size: { width: 500, height: 400 },
                                    chartid: 'sample' + sample.Id + '-' + rn + '-' + i + '-' + '3d'
                                };
                                sample.contour = {
                                    pdata: targetEntity.Data.contour,
                                    peaks: sample.Peaks,
                                    size: { width: 530, height: 400 },
                                    chartid: 'sample' + sample.Id + '-' + rn + '-' + i + '-' + 'contour'
                                };
                                // that.targetSamples.push(sample);
                                if(i===0) that.targetSample1 = sample;
                                else if(i===1) that.targetSample2 = sample;
                                else if(i===2) that.targetSample3 = sample;
                            }
                        }
                    }
                    that.showResultChart = true;
                    that.isSyncBtnShow = true;
                    that.$message({
                        message: "计算成功",
                        type: 'success'
                    });
                } else {
                    that.$message.error("计算失败");
                }
                this.isloading = false;
                this.loadingText = "";
            },
            //事件:开始同步
            async startSync() {
                if (this.calcid > 0) {
                    this.loadingText = "正在同步中...请稍等";
                    this.isloading = true;
                    var params = {
                        observationId: this.meta.id,
                        calcId: this.calcid
                    };
                    let res = await UpdateCalcId(params).catch(() => { });
                    if (res.Code === 1) {
                        this.$message({
                            message: "同步成功",
                            type: 'success'
                        });
                        this.calcid = 0;
                        this.isSyncBtnShow = false;
                    } else {
                        this.$message.error("同步失败");
                    }
                    this.isloading = false;
                    this.loadingText = "";
                }
                else {
                    this.$message.error("请先进行溯源计算");
                }
            }
        }
    }
</script>

<style scoped>
    .compareForm{
        margin-top:40px;
    }
</style>
